module.exports = __webpack_public_path__ + "media/images/p_big3-5299456a01e4370864f36126ac35b8a8.jpg";